import { loginCheck } from '@/api/user';
import { getUser, setUser } from '@utils/auth';
import { auth, env, JS2Native, coolHref, webSDK } from '@igetcool/base-components';
import { getServerTime } from '@/api/shoppingCar';
import { getUserSubscribe, getGoodsJumpUrl } from '@/api/goods';
import { getInUseAppId } from '@/api/order';

const actions = {
  // 校验登陆
  async acCheckApiLogin({ commit }) {
    try {
      const res = await loginCheck();
      res && commit('muSetApiLoginStatus', true);
      return res;
    } catch (error) {

    }
  },
  // 获取本地缓存中的用户信息
  acGetStorageUserInfo({ commit }) {
    commit('muSetUserInfo', JSON.parse(getUser()) || {});
  },
  // 微信授权
  async acPutWxAuth({ commit }, params) {
    const res = await auth.config({
      appId: 'wx84548acb6218fb8b',
      passgoServer: process.env.VUE_APP_PASSGO_SERVER,
      ...params
    }).doAuth();
    commit('muSetWxUserInfo', res);
    return res;
  },
  // 端内获取用户信息
  async acPutAppUserinfo({ commit, dispatch }, params) {
    const userInfo = {};
    try {
      const { data } = await JS2Native({ name: 'getAppUserPid' });
      if (data) {
        // 已登陆
        const { data: info } = await JS2Native({ name: 'getUserInfo' });
        userInfo['App-Device-Key'] = info['App-Device-Key'];
        userInfo['App-Device-Du-Key'] = info['App-Device-Du-Key'];
        userInfo['App-Device-Type'] = info['App-Device-Type'];
        userInfo['APP-Agent'] = info['App-Version'];
        userInfo['App-Sign'] = info['App-Token'];
        userInfo['uid'] = data;
        userInfo['App-nickName'] = info['nickName'];

        userInfo['App-Version'] = info['App-Version'];
        userInfo['App-Channel'] = info['App-Channel'];
        userInfo['isLogin'] = info['isLogin'];

      }
    } catch (error) {
    }
    commit('muSetUserInfo', userInfo);
    commit('muSetApiLoginStatus', true);
    setUser(JSON.stringify(userInfo));
    return userInfo;
  },
  async acAppLogin({ commit, dispatch }, params) {
    const res = await JS2Native({ name: 'doLogin' });
    // const uid = res.data;
    return res;
  },

  // 获取服务器时间
  async acGetServerTime({ commit }) {
    let res = {};
    try {
      res = await getServerTime();
      const time = res.data.replace(/-/g, '/');
      res.stamp = new Date(time).getTime();
      const subStamp = new Date().getTime() - res.stamp;
      res.subStamp = Math.abs(subStamp) >= 2000 ?  subStamp : 0;
    } catch (error) {
      res = {
        stamp: new Date().getTime(),
        subStamp: 0
      };
    }

    commit('muServerDate', res);
    return res;
  },

  async acGetUserSubscribe({ commit }, params) {
    const res = await getUserSubscribe({
      appId: 'wx7dff126205e4b443',  // 少年得到微信公众号APPID
      ...params
    });
    commit('muFocusWxcode', res.data);
    return res;
  },

  /**
   * openApp
   * @param {needJump} 是否跳转
   * @param {jumpType} 跳转类型
   * @returns jumpUrl  跳转地址
   */
  async acOpenApp(store, { needJump, jumpType, ...params }) {
    let res = {};
    switch (jumpType) {
      case 'books':
        res.data = 'igetcool://juvenile.dedao.app/go/main?params_tab=1&tab_name=book';
        break;
      default:
        res = await getGoodsJumpUrl(params);
        break;
    }

    if (needJump) {
      if (env.isApp) {
        coolHref(res.data);
      } else {
        webSDK.openApp(res.data, { invokeFailShowGuide: true });
      }
    }
    return res.data;
  },

  // 获取正在使用的公众号appId
  // @aigc:start 2024/09/14-14:56
  async acGetInUseAppId({ commit }) {
    let appId = '';
    // 少年得到微信公众号APPID
    // appId: 'wx7dff126205e4b443', name: '少年得到'
    // appId: 'wx52c85dc2fd62faa7', name: '少年得到测试'
    const defaultAppId = process.env.VUE_APP_ENVIRONMENT == 'PRODUCTION' ? 'wx7dff126205e4b443' : 'wx52c85dc2fd62faa7';
    try {
      const res = await getInUseAppId();
      if (res.code === 10000 && res.data) {
        if (res.data != defaultAppId) {
          appId = res.data;
        }
      }
    } catch (error) {
    }
    return appId;
  }
  // @aigc:end 2024/09/14-14:56
};
export default actions;
